import microuniversoApi from "app/api/microuniversoApi"
import { atualizarClienteAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { ICliente } from "app/types/ICliente"
import { atualizarOrcamento } from "../atualizarOrcamento"


export async function salvarNovoClienteOrcamento (identificadorOrcamento: string, cliente: ICliente) {
  const resposta = await microuniversoApi.Orcamento.salvarCliente(identificadorOrcamento, cliente)

  if (!("Error" in resposta)) {
    await atualizarOrcamento()
    store.dispatch(atualizarClienteAction({
      Cliente: resposta,
      CodigoCliente: resposta.Codigo,
      NomeCliente: resposta.Nome
    }))
  }
  
  return resposta
}
